import { InstantLoanStateType } from "../../../Reducers/types"
import { Validators } from "../../types"

export const referenceDetailsValidators: Validators<InstantLoanStateType["referenceDetails"]> = {
  privacyAgreement(value, values) {},
  agreeToPolicy(value, values) {},
  agreeToAccurateInfo(value, values) {},
  agreeToShareInfo(value, values) {},
}
